import { FunctionComponent, memo, useCallback } from "react";
import { IProps } from "./tag-group-filter.types";
import { FieldInline, LabeledField, useQueryParameters } from "@edgetier/client-components";
import { faTag } from "@fortawesome/pro-solid-svg-icons";
import SelectTagGroups from "components-for/filters/select-tag-groups";
import "./tag-group-filter.scss";
import { Form, Formik } from "formik";
import { SubmitOnChange } from "@edgetier/components";
import Qs from "qs";
import { useHistory, useLocation } from "react-router-dom";
import { clearUrlParameters } from "@edgetier/utilities";
import useTagGroups from "hooks-for/tag-groups/use-tag-groups";
import { TagGroupType } from "@edgetier/watchtower-types";
/**
 * Select a tag group then display default filter and table*
 * @returns Tag group select
 */
const TagGroupFilter: FunctionComponent<IProps> = () => {
    const { push } = useHistory();
    const { search } = useLocation();

    const { tagGroupId: parsedTagGroupId, agentTagGroupId } = useQueryParameters({
        tagGroupId: String,
        agentTagGroupId: String,
    });

    const { data: agentTagGroupIds } = useTagGroups(
        { tagGroupType: TagGroupType.Agent },
        { select: (tagGroups) => tagGroups.map((tagGroup) => tagGroup.tagGroupId) }
    );

    /**
     * Update the URL when the form values change.
     * @param values Form values.
     */
    const onChange = useCallback(
        (values: { tagGroupId: string }) => {
            const isAgentTagGroup = agentTagGroupIds?.includes(values.tagGroupId);
            const finalValues = isAgentTagGroup ? { agentTagGroupId: values.tagGroupId } : values;

            const parameters = Qs.parse(search, { ignoreQueryPrefix: true });
            const { tagGroupId, agentTagGroupId, ...clearedSearchParameters } = clearUrlParameters(parameters);
            push(
                Qs.stringify(
                    { ...clearedSearchParameters, ...finalValues },
                    { addQueryPrefix: true, arrayFormat: "repeat" }
                )
            );
        },
        [agentTagGroupIds, push, search]
    );

    return (
        <Formik onSubmit={onChange} initialValues={{ tagGroupId: parsedTagGroupId ?? agentTagGroupId }}>
            <Form name="tag-group-filter">
                <div className="tag-group-filter">
                    <LabeledField label="Tag Group">
                        <FieldInline icon={faTag}>
                            <SelectTagGroups name="tagGroupId" isSingleSelect hasAddItemMenu={false} />
                        </FieldInline>
                    </LabeledField>
                </div>
                <SubmitOnChange delay={0} />
            </Form>
        </Formik>
    );
};

export default memo(TagGroupFilter);
